"use client";

import { type FC, type PropsWithChildren, useEffect } from "react";
import { ConfigContext, type ConfigContextValue } from "./ConfigContext";
import { useCabinetStore } from "./StoreContext";

type Props = PropsWithChildren<{ config: ConfigContextValue }>;

export const ConfigContextProvider: FC<Props> = ({ children, config }) => {
	const { state, api } = useCabinetStore();

	// biome-ignore lint/correctness/useExhaustiveDependencies: can't have config as dependency
	useEffect(() => {
		if (config.onStoreChange) config.onStoreChange(state, api);
	}, [state]);

	return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};
